import { v4 as uuidv4 } from 'uuid';

const initialState = {
    isError: false,
    isLoadingLabResults: false,
    labResults: null,
    selectedLabResult: null,
    user: null,
    errorMessage: null,
    logoutErr: false,
    deviceId: null,
    dependents: null,
    isGettingPDF: false,
    isLoadingImmunizationResults: false,
    immunizationResults: null,
    isLoadingVaccinationStatus: false,
    vaccinationStatus: null,
    isFetchingPvcPdf: false,
}

export default function api(state = initialState, action) {
    switch(action.type) {
        case "FETCH_LAB_RESULTS":
            return {
                ...state,
                isLoadingLabResults: true,
                isError: false,
                logoutErr: false,
            }
        case "RECEIVE_LAB_RESULTS":
            return {
                ...state,
                isLoadingLabResults: false,
                isError: false,
                logoutErr: false,
                labResults: action.data,
            }
        case "FETCH_IMMUNIZATION_RESULTS":
            return {
                ...state,
                isLoadingImmunizationResults: true,
                immunizationResults: [],
            }
        case "RECEIVE_IMMUNIZATION_RESULTS":
            return {
                ...state,
                isLoadingImmunizationResults: false,
                isError: false,
                immunizationResults: action.data,
            }
        case "FETCH_VACCINATION_STATUS":
            return {
                ...state,
                isLoadingVaccinationStatus: true,
                vaccinationStatus: '',
            }
        case "RECEIVE_VACCINATION_STATUS":
            return {
                ...state,
                isLoadingVaccinationStatus: false,
                isError: false,
                vaccinationStatus: action.data,
            }
        case "CLEAR_DATA":
            return {
                ...state,
                isLoadingLabResults: false,
                isError: false,
                logoutErr: false,
                labResults: null,
                selectedLabResult: null,
                user: null,
                dependents: null,
                selectedUser: null,
                isGettingPDF:false,
                isFetchingPvcPdf:false,
            }
        case "SET_SELECTED_LAB_RESULT":
            return {
                ...state,
                selectedLabResult: action.data,
            }
        case "SET_USER":
            return {
                ...state,
                user: action.data,
            }
        case "CREATE_DEVICE_ID":
            if (state.deviceId === null) {
                let deviceId = uuidv4();
                return {
                    ...state,
                    deviceId: deviceId,
                }
            } else {
                return {
                    ...state,
                }
            }
        case "FETCH_ERROR":
            return {
                ...state,
                isLoadingLabResults: false,
                isLoadingUsers: false,
                isError: true,
                errorMessage: action.error,
            }
        case "SET_ERROR_STATE":
            if (action.fetch === true) {
                return {
                    ...state,
                    isLoadingLabResults: false,
                    isLoadingUsers: false,
                    isLoadingImmunizationResults: false,
                    isLoadingVaccinationStatus: false,
                    isGettingPDF:false,
                    isFetchingPvcPdf:false,
                    isError: true,
                    errorMessage: action.error,
                }
            } else {
                return {
                    ...state,
                    isError: action.state,
                    errorMessage: action.error,
                }
            }
        case "SET_LOGOUT_ERROR_STATE":
            if (action.fetch === true) {
                return {
                    ...state,
                    isLoadingLabResults: false,
                    isLoadingUsers: false,
                    isError: true,
                    errorMessage: action.error,
                    logoutErr: true,
                }
            } else {
                return {
                    ...state,
                    isError: action.state,
                    errorMessage: action.error,
                }
            }
        case "SET_DEPENDENTS":
            return {
                ...state,
                dependents: action.data,
            }
        case "SET_DEPENDENTS_RESULTS":
            return{
                ...state,
                dependentResults: action.data,
            }
        case "SET_SELECTED_USER":
            return{
                ...state,
                selectedUser: action.data,
            }
        case "SET_GETTING_PDF":
            return{
                ...state,
                isGettingPDF:action.data
            }
        case "SET_FETCHING_PVC_PDF":
                return{
                    ...state,
                    isFetchingPvcPdf:action.data
                }
        default:
            return state;
    }
}
